module.exports = __webpack_public_path__ + "img/arrow-green.b0402174.svg";